import { ClientEvents } from 'common/events/ClientEvents';
import { useCallback } from 'react';
import { UseDishFirstExploreUrl } from 'src/pages/consumer/explore/useExploreUrl';
import { useTracker } from 'src/shared/hooks/useTracker';
import { DishFirstQueryParamsUpdates } from '../../../Constants';

interface UseTrackFiltersProps {
  filters: UseDishFirstExploreUrl;
}

export const useTrackFilterChange = ({ filters }: UseTrackFiltersProps) => {
  const tracker = useTracker();
  const {
    browseFilter,
    cuisineFilters,
    dietaryFilters,
    dishTypeFilters,
    ecoFilter: isEcoFriendlyPackaging,
    minRatingFilter,
    priceLevelFilters,
    proteinFilters,
    segmentFilters,
    spiceLevelFilters,
  } = filters;

  const trackFilterChange = useCallback(
    (updates: DishFirstQueryParamsUpdates) => {
      const filtersData = {
        browseFilter: browseFilter ?? undefined,
        cuisineFilters,
        dietaryFilters,
        dishTypeFilters,
        isEcoFriendlyPackaging,
        minRatingFilter,
        priceLevelFilters,
        proteinFilters,
        segmentFilters,
        spiceLevelFilters,
      };

      tracker.track(ClientEvents.SUBMIT_DISH_FILTER, {
        ...filtersData,
        ...updates,
      });
    },
    [
      browseFilter,
      cuisineFilters,
      dietaryFilters,
      dishTypeFilters,
      isEcoFriendlyPackaging,
      minRatingFilter,
      priceLevelFilters,
      proteinFilters,
      segmentFilters,
      spiceLevelFilters,
      tracker,
    ]
  );

  return {
    trackFilterChange,
  };
};
